// extracted by mini-css-extract-plugin
module.exports = {"arrow":"lY","dropMenu":"lZ","dropMenuInner":"l0","itemborder":"l1","dropDownCurrent":"l2","menuItem":"l3","langContainer":"l4","current":"l5","outlink":"l6"};